<template>
  <div
    class="section section-signup"
    :style="
      'background-image: url(' +
        myTheme.home_section_background_image +
        '); background-size: cover; background-position: top center; min-height: 700px;'
    "
    v-loading.fullscreen.lock="isLoading"
    element-loading-background="rgba(256, 256, 256, 0.6)"
  >
    <div class="dark-overlay"></div>
    <b-alert v-model="showError" variant="danger" dismissible>
      {{ $t('message.reset_Unauthenticated') }}
    </b-alert>
    <div class="container">
      <div class="row">
        <cards
          class="card-signup"
          style="margin-top:50px"
          header-classes="text-center"
          :style="{ color: myTheme.topMenu.normal.color }"
        >
          <template slot="header">
            <h3 class="card-title title-up">{{ $t('text.reset_your_password') }}</h3>
            <div class="social-line"></div>
          </template>
          <template>
            <ValidationProvider rules="required|email" v-slot="{ errors }">
              <fg-input
                tabindex="1"
                type="email"
                ref="email"
                id="email"
                v-model.lazy="resetData.email"
                class="no-border "
                :placeholder="$t('input.placeholder.email')"
                :error="errors[0]"
                inputClasses="white-input"
              >
              </fg-input>
            </ValidationProvider>
            <h3>{{ $t('text.now_create_a_password') }}</h3>
            <ValidationProvider
              rules="required|min:8|password:password_confirmation"
              v-slot="{ errors }"
            >
              <div class="input-group form-group center-align" role="group">
                <fg-input
                  tabindex="2"
                  class="no-border"
                  type="password"
                  ref="password"
                  id="password"
                  v-model.lazy="resetData.password"
                  :placeholder="$t('input.placeholder.enter_password')"
                  :error="errors[0]"
                  inputClasses="white-input"
                  style="width:100%; padding-right: 1px;"
                >
                </fg-input>
                <n-button
                  type="primary"
                  @click="switchVisability()"
                  round
                  icon
                  class="add-on-input icon-eye"
                  v-bind:style="myTheme.customizeButton"
                >
                  <span id="pass-status" class="fa fa-fw fa-eye "></span>
                </n-button>
              </div>
            </ValidationProvider>
            <ValidationProvider
              name="password_confirmation"
              rules="required"
              v-slot="{ errors }"
            >
              <fg-input
                tabindex="3"
                type="password"
                ref="password_confirmation"
                id="passwordConfirmation"
                data-vv-name="password_confirmation"
                v-model.lazy="resetData.password_confirmation"
                class="no-border "
                :placeholder="$t('input.placeholder.confirm_new_password')"
                :error="errors[0]"
                inputClasses="white-input"
                v-on:keyup.enter="newPassword()"
              >
              </fg-input>
            </ValidationProvider>
          </template>
          <div class="text-center">
            <n-button
              round
              :disabled="!isComplete"
              v-bind:style="myTheme.customizeButton"
              type="submit"
              id="form-submit"
              @click="newPassword()"
            >
              {{ isComplete ? $t('button.save_your_password') : $t('button.complete_details') }}
            </n-button>
          </div>
        </cards>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { FormGroupInput, Button, Cards } from "@/components";
import { ValidationProvider } from "vee-validate";
import "vue-loading-overlay/dist/vue-loading.css";
import { helpers } from "@/utilities";

export default {
  name: "reset-password",
  data() {
    return {
      getHelpers: helpers,
      resetData: {
        email: "",
        password: "",
        password_confirmation: "",
        token: ""
      },
      showError: false,
      showSuccess: false,
      isLoading: false,
    };
  },
  computed: {
    isComplete() {
      return (
        this.resetData.email &&
        this.resetData.password &&
        this.resetData.password_confirmation
      );
    }
  },
  components: {
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
    ValidationProvider,
    Cards
  },
  methods: {
    ...mapActions(["authRequest"]),
    newPassword() {
      //---- check the form validity before submitting the data
      this.isLoading = true;
      this.resetPostRequest(this.resetData)
        .then(response => {
          if (response && response.error) {
              this.showError = true;
              this.isLoading = false;
              setTimeout(() => {
                this.showError = false;
              }, 5000);
              return;
          }
          this.login();
        })
        .catch((e) => {
          this.captureException(e)
          this.showError = true;
          this.isLoading = false;
          setTimeout(() => {
            this.showError = false;
          }, 5000);
        });
    },
    switchVisability() {
      this.passwordField = document.querySelector("#password");
      var passStatus = document.getElementById("pass-status");
      if (this.passwordField.getAttribute("type") === "password") {
        this.passwordField.setAttribute("type", "text");
        passStatus.className = "fa fa-eye-slash";
      } else {
        this.passwordField.setAttribute("type", "password");
        passStatus.className = "fa fa-eye";
      }
    },
    login() {
      this.showError = false;
      this.isLoading = true;
      this.authRequest({
        email: this.resetData.email,
        password: this.resetData.password
      })
        .then(response => {
          if (response && response.error) {
            this.isLoading = false;
            this.showError = true;
              return;
          }
          this.isLoading = false;
          this.$router.push(this.$route.query.redirect || "/");
        })
        .catch((e) => {
          this.captureException(e)
          this.isLoading = false;
          this.showError = true;
        });
    }
  },
  mounted() {
    this.resetData.token = this.$route.query.token;
  }
};
</script>

<style scoped>
.form-group.input-group {
  padding: 0;
}
</style>
